import { authHeader, BASE_URL, handleResponse } from '@helpers/api';

export const sendMessageService = {
    sendMessage,
    sendBulkMessages,
};

function sendMessage(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/surveys/send-single`, requestOptions).then(handleResponse);
}

function sendBulkMessages(list) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(list),
    };

    return fetch(`${BASE_URL}api/surveys/send-bulk`, requestOptions).then(handleResponse);
}
